// @ts-expect-error adding global var to window
window.globalVar = "notReady";
export const setGlobalVarReadyWithTimeout = () => {
  // @ts-expect-error adding global var to window
  setTimeout(() => (window.globalVar = "ready"), 10000);
};
